import i18n from "../../plugin/i18n/i18n";

const labels = {
  namespaced: true,
  state: {
    // 因子コードとそれに紐づく項目名
    factorLabels: {
      BP_HIGH: i18n.t("notebook.sbp"),
      BP_LWST: i18n.t("notebook.dbp"),
      BMI: "BMI",
      WAIST: i18n.t("yourPhysicalInformation.waistCircumference"),

      HMG: i18n.t("bloodTestResult.hemoglobin"),
      TRIGLYCERIDE: i18n.t("bloodTestResult.triglyceride"),
      LDL_CHOLE: i18n.t("bloodTestResult.ldlCholesterol"),
      HDL_CHOLE: i18n.t("bloodTestResult.hdlcholesterol"),
      CREATININE: i18n.t("bloodTestResult.serumCreatinine"),
      TOT_CHOLE: i18n.t("bloodTestResult.totalCholesterol"),
      BLDS: i18n.t("bloodTestResult.fastingBloodSugarLevel"),
      GAMMA_GTP: i18n.t("bloodTestResult.γGtp"),
      SGOT_AST: "AST",
      SGPT_ALT: "ALT",

      OLIG_PROTE_CD: i18n.t("bloodTestResult.urinaryProtein"),

      DRNK_HABIT_RSPS_CD: i18n.t("yourLifestyle.averageNumberOfDrinkingDaysInAWeek"),
      TM1_DRKQTY_RSPS_CD: i18n.t('yourLifestyle.averageNumberOfAmountInAWeek'),
      SMK_STAT_TYPE_RSPS_CD: i18n.t("yourLifestyle.smokingHabit"),
      MOV20_WEK_FREQ_ID: i18n.t("yourLifestyle.numberOfHigh-intensityExerciseDays"),
      MOV30_WEK_FREQ_ID: i18n.t("yourLifestyle.numberOfMid-intensityExerciseDays"),
      WLK30_WEK_FREQ_ID: i18n.t("yourLifestyle.numberOfLightExerciseDays"),
    },

    diseaseNames: {
      DM: i18n.t("diseases.diabetes"),
      LIVER: i18n.t("diseases.liverCancer"),
      BREAST: i18n.t("diseases.breastCancer"),
      DEMENTIA: i18n.t("diseases.dementia"),
      HEART: i18n.t("diseases.heartDisease"),
      STOMACH: i18n.t("diseases.stomachCancer"),
      COLORECTAL: i18n.t("diseases.colorectalCancer"),
      LUNG: i18n.t("diseases.langCancer"),
      STROKE: i18n.t("diseases.stroke"),
      PROSTATE: i18n.t("diseases.prostateCancer")
    },
    diseaseHistory: {
      HCHK_APOP_PMH_YN: i18n.t("diseases.stroke"),
      HCHK_DIABML_PMH_YN: i18n.t("diseases.diabetes"),
      HCHK_ETCDSE_PMH_YN: i18n.t("diseases.cancerOrOther"),
      HCHK_HDISE_PMH_YN: i18n.t("diseases.heartDisease"),
      HCHK_HPLPDM_PMH_YN: i18n.t("diseases.hyperlipemia"),
      HCHK_HPRTS_PMH_YN: i18n.t("diseases.highBloodPressure"),
      HCHK_PHSS_PMH_YN: i18n.t("diseases.tuberculosis"),
      FMLY_APOP_PATIEN_YN: i18n.t("diseases.stroke"),
      FMLY_CANCER_PATIEN_YN: i18n.t("diseases.cancerOrOther"),
      FMLY_DIABML_PATIEN_YN: i18n.t("diseases.diabetes"),
      FMLY_HDISE_PATIEN_YN: i18n.t("diseases.heartDisease"),
      FMLY_HPRTS_PATIEN_YN: i18n.t("diseases.highBloodPressure")
    },
    karadaStampLabels: {
      bowel: i18n.t("stamps.bowel"),
      alcohol: i18n.t("stamps.alcohol"),
      exercise: i18n.t("stamps.exercise"),
      conditionGood: i18n.t("stamps.conditionGood"),
      conditionBad: i18n.t("stamps.conditionBad"),
      medicine: i18n.t("stamps.medicine")
    }
  }
};

export default labels;